import { ApiDataAccess, ReadonlyHttpApiRepository, Result } from '@softline/core';
import { inject, Injectable } from '@angular/core';
import { SOFTLINE_API_GEWICHTSPORTAL_TEMPLATE } from '../gewichtsportal.api';
import { WeightReport } from '../types/weight-report.model';
import { DefaultValuePayload } from '../types/default-value-payload';

@Injectable()
export class DefaultValueRepository extends ReadonlyHttpApiRepository<
  Result<WeightReport>,
  DefaultValuePayload
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_GEWICHTSPORTAL_TEMPLATE);
  }

  override getLoadPayload(params: DefaultValuePayload): unknown | undefined {
    return params;
  }
}
